import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['form'];

  handleFileUpload(event) {
    const inputTarget = event.target;

    if (this.formTarget && inputTarget.files.length > 0) {
      this.formTarget.requestSubmit();
    }
  }
}
